import * as React from 'react';
import { UitkCard, UitkCardContent, UitkCardTextSegment } from 'uitk-react-cards';
import { UitkExpandoList } from 'uitk-react-expando';

import { SchemaOrgScript } from 'src/common/components/common/schema-org-script/schema-org-script';
import { FaqUtils } from 'src/common/utils/faq-utils';
import { PropertyFaqsViewModel } from 'src/common/models';

import { Expando } from './expando';

interface PropertyFaqsProps {
  propertyFaqs: PropertyFaqsViewModel;
}

export const PropertyFaqs: React.FC<PropertyFaqsProps> = ({ propertyFaqs }: PropertyFaqsProps) => {
  if (!propertyFaqs || !propertyFaqs.faqs || !propertyFaqs.faqs.length) {
    return null;
  }

  const { faqs, title } = propertyFaqs;

  const structuredData = FaqUtils.generateSchema(faqs);

  return (
    <div className="Faq uitk-cell all-cell-1-1 all-y-margin-three">
      <SchemaOrgScript structuredData={structuredData} />
      <UitkCard>
        <UitkCardContent>
          <UitkCardTextSegment>
            <h2 className="uitk-type-heading-600 all-y-padding-three">{title}</h2>
            <UitkExpandoList>
              {faqs.map((faq, index) => (
                <Expando
                  key={`faq-${index}`}
                  callToActionText={faq.question}
                  expandedText={faq.answer}
                  data-testid={`faq-${index}`}
                  rfrr={`question.${index}`}
                  analyticsDescription="See frequently asked questions"
                />
              ))}
            </UitkExpandoList>
          </UitkCardTextSegment>
        </UitkCardContent>
      </UitkCard>
    </div>
  );
};

PropertyFaqs.displayName = 'PropertyFaqs';
